import React, { useState } from "react";
import { Box, Typography, IconButton, Collapse } from "@mui/material";
import { MapProtectedRainforestArea } from "types/map";
import { RainforestTreeIcon } from "components/icons";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

type Props = {
  protectedRegions: MapProtectedRainforestArea[];
  isMobile: boolean;
};

const MapLegendRainforestPanelRegions = ({
  protectedRegions,
  isMobile,
}: Props) => {
  const [expanded, setExpanded] = useState(!isMobile);

  if (protectedRegions.length === 0) return null;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: isMobile ? 0.5 : 1 }}>
          <RainforestTreeIcon />
          <Typography
            variant={isMobile ? "subtitle2" : "subtitle1"}
            fontWeight="bold"
          >
            Foreco project regions
          </Typography>
        </Box>
        <IconButton
          size="small"
          onClick={() => setExpanded(!expanded)}
          sx={{ ml: "auto" }}
        >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={expanded}>
        <Box
          sx={{
            ml: isMobile ? 3.5 : 4,
            mt: 1,
            display: "flex",
            flexDirection: "column",
            gap: 0.75,
          }}
        >
          {protectedRegions.map((region, index) => {
            return (
              <Box
                key={index}
                sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
              >
                <Box
                  sx={{
                    width: isMobile ? 14 : 16,
                    height: isMobile ? 14 : 16,
                    backgroundColor: region.areaFillColor,
                    border: `2px solid ${region.areaStrokeColor}`,
                    borderRadius: "50%",
                    flexShrink: 0,
                  }}
                />
                <Typography variant={"caption"}>{region.name}</Typography>
              </Box>
            );
          })}
        </Box>
      </Collapse>
    </Box>
  );
};

export default MapLegendRainforestPanelRegions;
